// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__1fgrs","menu":"styles_menu__1Nf4A","clock":"styles_clock__2znWk"};